import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const RedTeaming: React.FC = () => {
  const sections = [
    {
      title: 'Advanced Red Team Operations',
      content: 'Our red team services provide comprehensive security testing that simulates sophisticated, multi-vector attacks against your organization. Unlike traditional penetration testing, red team exercises test your overall security posture, including people, processes, and technology, providing a realistic assessment of your defensive capabilities.',
      benefits: [
        'Multi-phase attack simulation',
        'Advanced persistent threat (APT) modeling',
        'Social engineering and human factor testing',
        'Physical security breach attempts',
        'Detection and response capability assessment'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Red Teaming"
      subtitle="Advanced red team operations that simulate sophisticated multi-vector attacks to test your organization's overall security posture."
      sections={sections}
    />
  );
};

export default RedTeaming;

